import React from "react"
import { Box, Typography } from "@mui/material"
import { AppButtonIcon } from "@components"
import { truncateString } from "@utils"


export default function nameColumn() {
	return {
		name: "file_name", label: "File Name",
		options: {
			customBodyRowRenderLite: (value, row) => <Box
				sx={{ textAlign: 'center', display: "flex", justifyContent: "center" }}>
				<Typography sx={{ p: 1 }}>{truncateString(value || "", 35)}</Typography>

				{row.export_url && <AppButtonIcon
					icon="file-arrow-down"
					tooltip="Download raw batch file"
					onClick={e => {
						window.open(row.export_url)
						if (e.ctrlKey) e.preventDefault()
					}}
					onAuxClick={e => {
						if (e.button === 1) {
							window.open(row.export_url)
							e.preventDefault()
						}
					}}
				/>}
			</Box>
		}
	}
}